<script>
import { mapGetters } from 'vuex'
import Translatable from '@src/mixins/translatable.js'
import PlanCard from '@components/plan-page/plan-card.vue'

export default {
  components: {
    PlanCard,
  },
  mixins: [Translatable],
  computed: {
    ...mapGetters('plan', ['pageData']),
    ...mapGetters('translations', ['currentLanguage']),
    planList() {
      if (!this.pageData?.content?.en?.plan) {
        return []
      }

      const localizedPlan =
        this.pageData.content[this.currentLanguage]?.plan || []
      const fallbackPlan = this.pageData.content.en.plan

      const webImages = this.pageData.plan_web_images || []
      const contentList = this.pageData.plan_content || []

      return fallbackPlan.map((fallbackItem, index) => {
        const localizedItem = localizedPlan[index]

        const title = localizedItem?.title || fallbackItem.title
        const text = localizedItem?.text || fallbackItem.text
        const buttonText =
          localizedItem?.button || fallbackItem.button || 'Learn More'

        const contentData = contentList[index] || {}
        const imagePath = webImages[index] || ''

        let href = ''
        let download = false

        if (index !== 0) {
          if (contentData.url) {
            href = contentData.url
          } else if (contentData.pdf) {
            href = `${process.env.VUE_APP_STATIC_URL}${contentData.pdf}`
            download = true
          }
        }

        return {
          _id: index + 1,
          title: title,
          text: text,
          image: [imagePath, ''],
          buttonText: buttonText,

          isAppButtons: index === 0,
          appUrls: contentData.urls || [],
          href: href,
          target: '_blank',
          download: download,
        }
      })
    },
  },
}
</script>

<template>
  <div class="content">
    <PlanCard v-for="step in planList" :key="step._id" :step="step" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.content {
  display: grid;
  justify-items: center;
  row-gap: 70px;
  grid-template-columns: repeat(1, 1fr);
}

@media only screen and (max-width: $container-width-xs) {
  .content {
    row-gap: 35px;
  }
}
</style>
